import React, { useContext, useEffect, useState } from "react";
import { useSnackbar } from "notistack";

import app, { firebase } from "../../configurations/firebase";
import { AuthContext } from "../AuthContext/AuthContext";

export const ClientContext = React.createContext({});

export const ClientProvider = ({ children }) => {
  const { profile, role } = useContext(AuthContext);

  const [clients, setClients] = useState(null);
  const [selectedClient, setSelectedClient] = useState(null);
  const [loading, setLoading] = useState(false);

  const { enqueueSnackbar } = useSnackbar();

  const addClientData = (dataObj) => {
    setLoading(true)
    app
      .firestore()
      .collection("users")
      .add({
        ...dataObj,
        createdAt: firebase.firestore.Timestamp.fromDate(new Date()),
        createdBy: profile,
      })
      .then((docRef) => {
        console.log("Document written with ID: ", docRef.id);
        enqueueSnackbar("Document written", { variant: "success" });
        getClientDataAll()
        setLoading(false)
      })
      .catch((e) => {
        console.error("Error adding document: ", e);
        enqueueSnackbar(e.message, { variant: "error" });
        setLoading(false)
      });
  };

  const setClientData = (dataId, dataObj) => {
    setLoading(true)
    console.log(dataId, dataObj);
    app
      .firestore()
      .collection("users")
      .doc(dataId)
      .set({
        ...dataObj,
        createdAt: firebase.firestore.Timestamp.fromDate(new Date()),
        createdBy: profile,
      })
      .then(() => {
        console.log("Document written with ID: ", dataId);
        enqueueSnackbar("Document written", { variant: "success" });
        getClientDataAll()
        setLoading(false)
      })
      .catch((e) => {
        console.error("Error adding document: ", e);
        enqueueSnackbar(e.message, { variant: "error" });
        setLoading(false)
      });
  };

  const updateClientData = (dataId, dataObj) => {
    setLoading(true)
    app
      .firestore()
      .collection("users")
      .doc(dataId)
      .update({
        ...dataObj,
        modifiedAt: firebase.firestore.Timestamp.fromDate(new Date()),
        modifiedBy: profile,
      })
      .then(() => {
        console.log("Document successfully written!");
        enqueueSnackbar("Document successfully updated!", {
          variant: "success",
        });
        getClientDataAll()
        setLoading(false)
      })
      .catch((e) => {
        console.error("Error writing document: ", e);
        enqueueSnackbar(e.message, { variant: "error" });
        setLoading(false)
      });
  };

  const deleteClientData = (dataId) => {
    setLoading(false)
    app
      .firestore()
      .collection("users")
      .doc(dataId)
      .delete()
      .then(() => {
        console.log("Document successfully deleted!");
        enqueueSnackbar("Document successfully deleted!", {
          variant: "success",
        });
        getClientDataAll()
        setLoading(false)
      })
      .catch((e) => {
        console.error("Error removing document: ", e);
        enqueueSnackbar(e.message, { variant: "error" });
        setLoading(false)
      });
  };

  const getClientDataAll = () => {
    setLoading(true)
    app
      .firestore()
      .collection("users")
      .where('isAdmin', '==', false)
      .where('roles', 'array-contains', 'client')
      .orderBy('createdAt', 'desc')
      .get()
      .then((querySnapshot) => {
        const arr = [];
        querySnapshot.forEach((doc) => {
          arr.push({ id: doc.id, ...doc.data() });
        });
        setClients(arr);
        setLoading(false)
      })
      .catch((e) => {
        console.log("Error", e);
        enqueueSnackbar(e.message, { variant: "error" });
        setLoading(false)
      });
  };

  const getClientDataByClient = () => {
    setLoading(true)
    setClients([profile])
    console.log([profile])
  };

  useEffect(() => {
    if (role === 0) { getClientDataAll() } else { getClientDataByClient() }
  }, [role, profile]);

  return (
    <ClientContext.Provider
      value={{
        loading,
        clients,
        selectedClient,
        setSelectedClient,
        getClientDataAll,
        addClientData,
        setClientData,
        updateClientData,
        deleteClientData
      }}
    >
      {children}
    </ClientContext.Provider>
  );
};
